/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

export const StyledData = styled.div`
  font-family: IBM Plex Mono;
  color: ${({ theme }) => theme.text.subtle};
  font-size: 10px;
  margin-bottom: 5px;
  @media print {
    display: none;
  }
`;
